export enum Library {
  common = 'common',
  userpath = 'userpath',
}
